import iPaperclip from "../../../assets/icons/paperclip.svg";
import "./button-file.sass";

type Props = {
  onClick?: () => void;
};

const ButtonFile = ({ onClick }: Props) => {
  return (
    <div className="button-file" onClick={onClick}>
      <img src={iPaperclip} className="button-file__img" alt="" />
    </div>
  );
};

export default ButtonFile;
